import BaseApi from './baseApi';
import IUsersNotifications from '../models/IUserNotification';

export default class UsersNotificationsApi extends BaseApi {
    constructor() {
        super("dataaccess", "Dashboard");
    }

    async GetNotificationsByUserId(userId: string) : Promise<IUsersNotifications[]> {
        let json : string = this.getJsonReadWithIdUser(userId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var notifications: IUsersNotifications[] = [];
            notifications = response.data as IUsersNotifications[];
            return notifications;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async GetNotificationsNotifyByUserId(userId: string) : Promise<IUsersNotifications[]> {
        let json : string = this.getJsonReadNotifiedWithIdUser(userId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var notifications: IUsersNotifications[] = [];
            notifications = response.data as IUsersNotifications[];
            return notifications;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async UpdateNotificationToRead(notificationId: string) : Promise<boolean> {
        const json = this.getJsonUpdateReading(notificationId);
        const response = await this.api.post('SaveWithParameters', json);
        return this.isSuccess(response);
    }

    async UpdateNotificationToNotify(notificationId: string) : Promise<boolean> {
        const json = this.getJsonUpdateNotify(notificationId);
        const response = await this.api.post('SaveWithParameters', json);
        return this.isSuccess(response);
    }

    private getJsonUpdateReading(notificationId: string) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "IsRead",
                "Item2": true
            }],
            "table": "UsersNotifications",
            "conditions": [{
                "Item1": "UsersNotifications",
                "Item2": "id",
                "Item3": "=",
                "Item4": notificationId
            }]
        };
        return json;
    }

    private getJsonUpdateNotify(notificationId: string) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "IsNotified",
                "Item2": true
            }],
            "table": "UsersNotifications",
            "conditions": [{
                "Item1": "UsersNotifications",
                "Item2": "id",
                "Item3": "=",
                "Item4": notificationId
            }]
        };
        return json;
    }

    private getJsonReadNotifiedWithIdUser(idUser: string) : any {
        const json = {
            "fields": [{
                "Item1": "UsersNotifications",
                "Item2": "id"
            }, {
                "Item1": "UsersNotifications",
                "Item2": "type"
            }, {
                "Item1": "UsersNotifications",
                "Item2": "identifier"
            }, {
                "Item1": "UsersNotifications",
                "Item2": "subject"
            }, {
                "Item1": "UsersNotifications",
                "Item2": "body"
            }, {
                "Item1": "UsersNotifications",
                "Item2": "isNotified"
            }, {
                "Item1": "UsersNotifications",
                "Item2": "isRead"
            }, {
                "Item1": "UsersNotifications",
                "Item2": "idUser"
            }],
            "tables": [{
                "Item1": "UsersNotifications"
            }],
            "conditions": [{
                "Item1": "UsersNotifications",
                "Item2": "isNotified",
                "Item3": "=",
                "Item4": "1",
                "ITem5": "AND"
            }, {
                "Item1": "UsersNotifications",
                "Item2": "isRead",
                "Item3": "=",
                "Item4": "0",
                "ITem5": "AND"
            }, {
                "Item1": "UsersNotifications",
                "Item2": "idUser",
                "Item3": "=",
                "Item4": idUser
            }]
        };
        return json;
    }

    private getJsonReadWithIdUser(idUser: string) : any {
        const json = {
            "fields": [{
                "Item1": "UsersNotifications",
                "Item2": "id"
            }, {
                "Item1": "UsersNotifications",
                "Item2": "type"
            }, {
                "Item1": "UsersNotifications",
                "Item2": "identifier"
            }, {
                "Item1": "UsersNotifications",
                "Item2": "subject"
            }, {
                "Item1": "UsersNotifications",
                "Item2": "body"
            }, {
                "Item1": "UsersNotifications",
                "Item2": "isNotified"
            }, {
                "Item1": "UsersNotifications",
                "Item2": "isRead"
            }, {
                "Item1": "UsersNotifications",
                "Item2": "idUser"
            }],
            "tables": [{
                "Item1": "UsersNotifications"
            }],
            "conditions": [{
                "Item1": "UsersNotifications",
                "Item2": "isNotified",
                "Item3": "=",
                "Item4": "0",
                "ITem5": "AND"
            }, {
                "Item1": "UsersNotifications",
                "Item2": "idUser",
                "Item3": "=",
                "Item4": idUser
            }]
        };
        return json;
    }
}
